import React from "react";
import { followUpOrTimingWithLabel } from "../../lib/formatters";
import styles from "../../styles/outcomeTable.module.scss";

const OutcomeName = ({ outcome }) => {
  return (
    <div>
      <div className={styles.outcomeName}>
        <h4>{outcome.name}</h4>
        <div className={styles.followUp}>
          {followUpOrTimingWithLabel(outcome)}
        </div>
      </div>
    </div>
  );
};

export default OutcomeName;
